import { IBatteryData } from '../../../../app/entities/BatteryData'
import { IVanPartial } from '../../../../app/entities/Van'

function getBatteryDataForVan(van: IVanPartial): IBatteryData[] {
  return (
    van.vanBatteryDataBindings?.map(
      (binding) => binding.mostRecentBatteryData as IBatteryData,
    ) || []
  ).filter((data): data is IBatteryData => data !== undefined)
}

export default getBatteryDataForVan
